import { render, staticRenderFns } from "./ApiSmsApi.vue?vue&type=template&id=3dd71577&scoped=true&"
import script from "./ApiSmsApi.vue?vue&type=script&lang=js&"
export * from "./ApiSmsApi.vue?vue&type=script&lang=js&"
import style0 from "./ApiSmsApi.vue?vue&type=style&index=0&id=3dd71577&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd71577",
  null
  
)

export default component.exports